import React from 'react'
import getAutoTutorRecommendations from '../../../helpers/assessment/getAutoTutorRecommendations'

export default function AreasToImprove({byNode, bySubtest, subject, nodes, isGroup, }) {
  const recs = getAutoTutorRecommendations({byNode, bySubtest, subject, nodes}, false, isGroup)

  return (
    <div className="areas-to-improve">
      <h3>Top Areas to Improve</h3>
      <ul>
        {recs.map((rec, n) => 
          <li key={`autoTutRec${subject}${n}`}>{rec}</li>
        )}
      </ul>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/AreasToImprove.js